import {Pipe, PipeTransform} from '@angular/core';
import {NgxTranslations} from '@ngx-translations/translations.service';

@Pipe({
    name: 'format'
})
export class FormatPipe implements PipeTransform {

    readonly intervals = [
        {singular: 'year', plural: 'years', seconds: 31536000},
        {singular: 'month', plural: 'months', seconds: 2592000},
        {singular: 'day', plural: 'days', seconds: 86400},
        {singular: 'hour', plural: 'hours', seconds: 3600},
        {singular: 'minute', plural: 'minutes', seconds: 60},
        {singular: 'second', plural: 'seconds', seconds: 0}
    ];

    constructor(private _translate: NgxTranslations) {
    }

    transform(value: any, format?: string, timezone?: string): any {
        if (format === 'duration') {
            return this.toDuration(value);
        }

        if (format === 'time') {
            return this.toTime(value);
        }

        if (format === 'views') {
            return this.toViews(value);
        }

        return null;
    }

    private toViews(value: number, fractionDigits = 0, thousandSeparator = '.', fractionSeparator = ',') {
        if (value !== 0 && !value || !Number.isFinite(value)) {
            return value;
        }
        const frDigits = Number.isFinite(fractionDigits) ? Math.min(Math.max(fractionDigits, 0), 7) : 0;
        const num = value.toFixed(frDigits).toString();

        const parts = num.split('.');
        let digits = parts[0].split('').reverse();
        let sign = '';
        if (parseInt(num) < 0) {
            sign = digits.pop();
        }
        let final = [];
        let pos = 0;

        while (digits.length > 1) {
            final.push(digits.shift());
            pos++;
            if (pos % 3 === 0) {
                final.push(thousandSeparator);
            }
        }
        final.push(digits.shift());
        return `${sign}${final.reverse().join('')}${frDigits > 0 ? fractionSeparator : ''}${frDigits > 0 && parts[1] ? parts[1] : ''}`;
    }

    private toTime(value: number) {
        return [(value / 3600), ((value % 3600) / 60), ((value % 3600) % 60)]
            .map(v => v < 10 ? '0' + parseInt(v + '') : parseInt(v + ''))
            .filter((i, j) => i !== '00' || j > 0)
            .join(':');
    }

    private toDuration(value: string) {
        const date = new Date(value + '+00:00');

        if (!date) {
            return null;
        }

        const current = new Date();

        const seconds = Math.floor(current.getTime() - date.getTime()) / 1000;
        const interval = this.intervals.find(i => i.seconds < seconds);
        const count = Math.floor(seconds / Math.max(1, interval.seconds));
        const word = count === 1 ? interval.singular : interval.plural;
        const wordTranslation = this._translate.instant(word);
        const agoTranslation = this._translate.instant('ago');
        return `${count} ${wordTranslation} ${agoTranslation}`;
    }

}
